/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSharedGanttChartModule } from '@gh/builder-shared-gantt-chart';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';

import { BuilderSchedulingRoutingModule } from './builder-scheduling-routing.module';
import {
  ConstructionScheduleListComponent,
} from './components/construction-schedule-list/construction-schedule-list.component';
import {
  ConstructionWorksheetTopFormComponent,
} from './components/construction-worksheet/construction-worksheet-top-form/construction-worksheet-top-form.component';
import { ConstructionWorksheetComponent } from './components/construction-worksheet/construction-worksheet.component';
import {
  JobScheduleCreateDialogComponent,
} from './components/job-schedule-create-dialog/job-schedule-create-dialog.component';
import {
  MaintenanceScheduleListComponent,
} from './components/maintenance-schedule-list/maintenance-schedule-list.component';
import {
  PreConstructionScheduleListComponent,
} from './components/pre-construction-schedule-list/pre-construction-schedule-list.component';
import {
  PreConstructionWorksheetComponent,
} from './components/pre-construction-worksheet/pre-construction-worksheet.component';
import {
  WorksheetTemplateDialogComponent,
} from './components/pre-construction-worksheet/worksheet-template-dialog/worksheet-template-dialog.component';
import {
  SalesScheduleCreateDialogComponent,
} from './components/sales-schedule-create-dialog/sales-schedule-create-dialog.component';
import { SalesScheduleListComponent } from './components/sales-schedule-list/sales-schedule-list.component';
import {
  ScheduleCombinedGanttDetailsComponent,
} from './components/schedule-combined-gantt-details/schedule-combined-gantt-details.component';
import {
  ConstructionScheduleDetailsTopFormComponent,
} from './components/schedule-details/construction-schedule-details-top-form/construction-schedule-details-top-form.component';
import {
  ConstructionScheduleDetailsComponent,
} from './components/schedule-details/construction-schedule-details/construction-schedule-details.component';
import {
  PreMainScheduleDetailsTopFormComponent,
} from './components/schedule-details/pre-main-schedule-details-top-form/pre-main-schedule-details-top-form.component';
import {
  PreMainScheduleDetailsComponent,
} from './components/schedule-details/pre-main-schedule-details/pre-main-schedule-details.component';
import {
  SalesScheduleDetailsTopFormComponent,
} from './components/schedule-details/sales-schedule-details-top-form/sales-schedule-details-top-form.component';
import {
  SalesScheduleDetailsComponent,
} from './components/schedule-details/sales-schedule-details/sales-schedule-details.component';
import {
  ScheduleDetailsTaskListComponent,
} from './components/schedule-details/schedule-details-task-list/schedule-details-task-list.component';
import { ScheduleFinderDialogComponent } from './components/schedule-finder-dialog/schedule-finder-dialog.component';
import { ScheduleGanttDetailsComponent } from './components/schedule-gantt-details/schedule-gantt-details.component';

import {
  ScheduleJobProgressFilterDialogComponent,
} from './components/schedule-job-progress-filter-dialog/schedule-job-progress-filter-dialog.component';
import {
  ScheduleSupervisorsReportFilterDialogComponent,
} from './components/schedule-supervisors-report-filter-dialog/schedule-supervisors-report-filter-dialog.component';
import {
  ScheduleSupervisorsReportFilterPrinterStepComponent,
} from './components/schedule-supervisors-report-filter-dialog/schedule-supervisors-report-filter-printer-step/schedule-supervisors-report-filter-printer-step.component';
import {
  ScheduleSupervisorsReportFilterSupplierStepComponent,
} from './components/schedule-supervisors-report-filter-dialog/schedule-supervisors-report-filter-supplier-step/schedule-supervisors-report-filter-supplier-step.component';
import {
  ScheduleSupervisorsReportFilterTaskStepComponent,
} from './components/schedule-supervisors-report-filter-dialog/schedule-supervisors-report-filter-task-step/schedule-supervisors-report-filter-task-step.component';
import {
  ScheduleTaskDetailsTopFormComponent,
} from './components/schedule-task-details/schedule-task-details-top-form/schedule-task-details-top-form.component';
import { ScheduleTaskDetailsComponent } from './components/schedule-task-details/schedule-task-details.component';
import {
  ScheduleTaskDetailsTodoDialogComponent,
} from './components/schedule-task-details/schedule-task-todo-dialog/schedule-task-todo-dialog.component';
import {
  ScheduleVendorFilterDialogComponent,
} from './components/schedule-vendor-filter-dialog/schedule-vendor-filter-dialog.component';
import { ConstructionWorksheetBusinessService } from './resources/construction-worksheet-business.service';
import { PreConstructionWorksheetBusinessService } from './resources/pre-construction-worksheet-business.service';
import {
  ScheduleCombinedGanttDetailsBusinessService,
} from './resources/schedule-combined-gantt-details-business.service';
import { ScheduleDetailsBusinessService } from './resources/schedule-details-business.service';
import { ScheduleFinderBusinessService } from './resources/schedule-finder-business.service';
import { ScheduleGanttDetailsBusinessService } from './resources/schedule-gantt-details-business.service';
import { ScheduleListBusinessService } from './resources/schedule-list-business.service';
import { ScheduleTaskDetailsBusinessService } from './resources/schedule-task-details-business.service';
import { WorksheetTemplateDialogBusinessService } from './resources/worksheet-template-dialog-business.service';
import {
  ScheduleConstructionReportDialogComponent,
} from './components/schedule-construction-report-dialog/schedule-construction-report-dialog.component';
import {
  ScheduleGanttHeaderDockComponent,
} from './components/schedule-gantt-details/schedule-gantt-details-headers/header-dock/schedule-gantt-header-dock.component';
import {
  ScheduleGanttHeaderTitleComponent,
} from './components/schedule-gantt-details/schedule-gantt-details-headers/header-titie/schedule-gantt-header-title.component';
import {
  ScheduleCheckUsageDialogComponent,
} from './components/schedule-check-usage-dialog/schedule-check-usage-dialog.component';

@NgModule({
  imports: [
    CoreUiExtSplitPaneModule,
    BuilderSharedGanttChartModule,
    BuilderSharedModule.forChild(),
    BuilderSchedulingRoutingModule,
  ],
  providers: [
    ScheduleListBusinessService,
    ScheduleDetailsBusinessService,
    ScheduleGanttDetailsBusinessService,
    ScheduleFinderBusinessService,
    ScheduleCombinedGanttDetailsBusinessService,
    ScheduleTaskDetailsBusinessService,
    PreConstructionWorksheetBusinessService,
    WorksheetTemplateDialogBusinessService,
    ConstructionWorksheetBusinessService,
  ],
  declarations: [
    ConstructionScheduleListComponent,
    PreConstructionScheduleListComponent,
    MaintenanceScheduleListComponent,
    SalesScheduleListComponent,
    JobScheduleCreateDialogComponent,
    SalesScheduleCreateDialogComponent,
    ConstructionScheduleDetailsComponent,
    PreMainScheduleDetailsComponent,
    SalesScheduleDetailsComponent,
    ConstructionScheduleDetailsTopFormComponent,
    PreMainScheduleDetailsTopFormComponent,
    SalesScheduleDetailsTopFormComponent,
    ScheduleDetailsTaskListComponent,
    ScheduleGanttDetailsComponent,
    ScheduleFinderDialogComponent,
    ScheduleCheckUsageDialogComponent,
    ScheduleCombinedGanttDetailsComponent,
    ScheduleTaskDetailsComponent,
    ScheduleTaskDetailsTopFormComponent,
    ScheduleTaskDetailsTodoDialogComponent,
    ScheduleJobProgressFilterDialogComponent,
    ScheduleSupervisorsReportFilterDialogComponent,
    ScheduleSupervisorsReportFilterTaskStepComponent,
    ScheduleSupervisorsReportFilterSupplierStepComponent,
    ScheduleSupervisorsReportFilterPrinterStepComponent,
    ScheduleVendorFilterDialogComponent,
    ScheduleConstructionReportDialogComponent,
    PreConstructionWorksheetComponent,
    WorksheetTemplateDialogComponent,
    ConstructionWorksheetComponent,
    ConstructionWorksheetTopFormComponent,
    ScheduleGanttHeaderDockComponent,
    ScheduleGanttHeaderTitleComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class BuilderSchedulingModule {

}
